import { useState, useEffect, useRef } from 'react';

import Delay from './Delay';

function Video({ url, poster, portrait = false }) {
    const player = useRef();

    const [isPlaying, setIsPlaying] = useState(false);
    const [isReady, setIsReady] = useState(false);
    const [isFullscreen, setIsFullscreen] = useState(false);

    useEffect(() => {
        console.log('Video', 'mount');

        if (player.current) {
            if (player.current.readyState >= 3) {
                onReady();
            }
        }

        return () => {
            console.log('Video', 'unmount');

            pause();
            if (player.current) {
                player.current.removeAttribute('src');
                player.current.load();
            }
        };
    }, []);

    function toggleFullscreen() {
        console.log('Video.toggleFullscreen()', isFullscreen);

        setIsFullscreen(!isFullscreen);
    }

    function togglePlayback() {
        console.log('Video.togglePlayback()', isPlaying);

        if (isPlaying) {
            pause();
        } else {
            play();
        }
    }

    function play() {
        console.log('Video.play()');

        if (!player.current) {
            return;
        }

        try {
            player.current.play().then(() => {});
        } catch (error) {}
    }

    function pause() {
        console.log('Video.pause()');

        if (!player.current) {
            return;
        }

        player.current.pause();
    }

    function onReady() {
        console.log('Video.onReady()');

        setIsReady(true);
        play();
    }

    function onPlay() {
        console.log('Video.onPlay()');

        setIsPlaying(true);

        if (player.current) {
            player.current.style.position = 'relative';

            setTimeout(() => {
                if (player.current) player.current.style.position = 'absolute';
            }, 10);
        }
    }

    function onPause() {
        console.log('Video.onPause()');

        setIsPlaying(false);
    }

    function onEnded() {
        console.log('Video.onEnded()');

        setIsPlaying(false);
    }

    return (
        <div
            className={`Video ${portrait ? 'portrait' : ''} ${isPlaying ? 'playing' : ''} ${isReady ? 'ready' : ''} ${
                isFullscreen ? 'fullscreen' : ''
            }`}
        >
            <div className="Video-fullscreenwrapper">
                <Delay delay="500">
                    <video
                        ref={player}
                        className="Video-player"
                        playsInline
                        onLoadedMetadata={onReady}
                        onPlay={onPlay}
                        onPause={onPause}
                        onEnded={onEnded}
                        src={url}
                        onClick={togglePlayback}
                        preload="auto"
                        style={{ backgroundImage: `url(${poster})` }}
                    ></video>
                </Delay>

                {isReady && (
                    <>
                        <button onClick={togglePlayback} className="Video-play">
                            {isPlaying ? 'pause' : 'play'}
                        </button>

                        <button onClick={toggleFullscreen} className="Video-fullscreen">
                            toggle fullscreen
                        </button>
                    </>
                )}

                {poster && (
                    <div className="Video-poster">
                        <img src={poster} className="VideoPlayer-poster-img"></img>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Video;
